import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const ModificationPowerFeedsForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<ChangeNames.MODIFICATION_POWER_FEEDS>();

    const convertValue = (): string => {
        if (values.modificationPowerFeeds.value.cable) return "cable";
        if (values.modificationPowerFeeds.value.overhead) return "overhead";
        return "";
    };
    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Welche Änderungen sollen am Stromnetzanschluss durchgeführt werden?
                </h4>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            setValues(values => {
                                values.modificationPowerFeeds.value = {
                                    cable: v.indexOf("cable") >= 0,
                                    overhead: v.indexOf("overhead") >= 0,
                                };
                            });
                        }}
                    >
                        <FormControlLabel
                            value="cable"
                            control={<Radio />}
                            label="Änderung Kabelnetzanschluss"
                            text=""
                            error={values.modificationPowerFeeds.error != null}
                        />
                        <FormControlLabel
                            value="overhead"
                            control={<Radio />}
                            label="Änderung Freileitung"
                            text=""
                            error={values.modificationPowerFeeds.error != null}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
